import React from 'react'
import { SvgIcon } from '../svg-icon'

import styles from './no-results-found-illustration.module.css'

/**
 * Define default props as fallback. See SvgIcon base className for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    keepPathColor: true,
    viewBoxSize: 300
}

/**
 * Stateless function representing an empty results indicator.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <NoResultsFoundIllustration width={300} />
 */
const NoResultsFoundIllustration = props => (
    <SvgIcon {...props}>
        <path
            className={styles['doc-shape-bg']}
            d={`M273,147c0,67.93-55.07,123-123,123S27,214.93,27,147S82.07,24,150,24S273,79.07,273,147z M46,39c-3.31,0-6,2.69-6,
            6s2.69,6,6,6s6-2.69,6-6S49.31,39,46,39z M222,31c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2s2-0.9,2-2C224,31.9,223.1,31,222,31z`}
        />
        <g>
            <path
                className={styles['doc-shape']}
                d={`M239.69,75.19l-53.88-53.88c-4.57-4.57-13.6-8.31-20.06-8.31H154h-5.88H83.5C70.58,13,60,23.57,60,
                36.5v218c0,12.92,10.58,23.5,23.5,23.5h141c12.92,0,23.5-10.58,23.5-23.5V95.25C248,88.79,244.26,79.76,
                239.69,75.19z M177.5,95.25c-6.46,0-11.75-5.29-11.75-11.75V30.62l64.62,64.62H177.5z`}
            />
        </g>
        <circle className={styles['dark-dot']} cx="260" cy="49" r="3" />
        <g>
            <path
                className={styles['doc-content']}
                d={`M145,87H82V77h63V87z M120,97H82v10h38V97z M222,111c-1.66,0-3,1.34-3,3s1.34,3,3,3s3-1.34,3-3S223.66,
                111,222,111z M212,111c-1.66,0-3,1.34-3,3s1.34,3,3,3s3-1.34,3-3S213.66,111,212,111z M202,111c-1.66,
                0-3,1.34-3,3s1.34,3,3,3s3-1.34,3-3S203.66,111,202,111z M145,57H82v10h63V57z M92,237H82v10h10V237z M53,
                249c0,1.66-1.34,3-3,3s-3-1.34-3-3s1.34-3,3-3S53,247.34,53,249z M34,71c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2s0.9-2,
                2-2C33.1,69,34,69.9,34,71z M260,35c0,3.31-2.69,6-6,6c-3.31,0-6-2.69-6-6s2.69-6,6-6C257.31,29,260,31.69,260,35z`}
            />
        </g>
        <path
            className={styles['magnifier']}
            d={`M251.59,283.59c-4.55,4.55-12,4.55-16.55,0l-20.76-20.76c6.28-4.7,11.85-10.27,16.55-16.55l20.76,20.76C256.14,
            271.59,256.14,279.04,251.59,283.59z M231.6,197.3c0,36.62-29.68,66.3-66.3,66.3S99,233.92,99,197.3c0-36.62,29.68-66.3,
            66.3-66.3S231.6,160.68,231.6,197.3z`}
        />
        <path
            className={styles['magnifier-bg']}
            d={`M44,239c0,3.31-2.69,6-6,6s-6-2.69-6-6s2.69-6,6-6S44,235.69,44,239z M165.3,248c-28,0-50.7-22.7-50.7-50.7s22.7-50.7,
            50.7-50.7s50.7,22.7,50.7,50.7S193.3,248,165.3,248z`}
        />
        <path
            className={styles['magnifier']}
            d={`M149.98,181c-3.85,0-6.98,3.12-6.98,6.98s3.12,6.98,6.98,6.98s6.98-3.12,6.98-6.98S153.83,181,149.98,181z M182.53,
            181c-3.85,0-6.98,3.12-6.98,6.98s3.12,6.98,6.98,6.98s6.98-3.12,6.98-6.98S186.38,181,182.53,181z M187.28,
            222.98c1.36-1.36,1.36-3.57,0-4.93c-5.62-5.62-13.08-8.71-21.02-8.71c-7.94,0-15.41,3.09-21.02,8.71c-1.36,1.36-1.36,
            3.57,0,4.93s3.57,1.36,4.93,0c4.3-4.3,10.01-6.67,16.09-6.67c6.08,0,11.79,2.37,16.09,6.67c0.68,0.68,1.57,1.02,2.47,
            1.02C185.7,224,186.59,223.66,187.28,222.98z`}
        />
    </SvgIcon>
)

NoResultsFoundIllustration.defaultProps = defaultProps

export { NoResultsFoundIllustration }
